const SET_ENLARGED_FONT_ENABLED = 'SET_ENLARGED_FONT_ENABLED';

export const accessibilityActionTypes = {
    SET_ENLARGED_FONT_ENABLED
};